import Vue from 'vue'
import { Component, Prop, Watch, Mixins } from 'vue-property-decorator'

import WebpartTemplate from '@webparts/components/webparts/base/WebpartTemplate.vue'
import WebpartBase from '@webparts/components/webparts/base/WebpartBase';
import { LoadingBar } from '@appbase/components/loading'
import NoData from '@webparts/components/common/NoData.vue'
import ExternalShortcutSettingModal from './ExternalShortcutSettingModal.vue'
import { mapGetters } from 'vuex'

import api from '@webparts/api/index';
import * as accouttypes from '@account/store/types'
import * as urlHelper from '@appbase/util/url-helper'
import { buildStyle } from "@appbase/util/popup-helper"

import SubtleRSA from '@appbase/util/subtle-rsa'
import { replaceUserKeyword } from '@appbase/util'

export interface GroupShortcutModel {
    id: number;
    displayName: string;
    childs: kyobobook.Shortcut[];
}

const tempData: GroupShortcutModel[] = [
    {
        id: 1,
        displayName: '교보문고 서비스',
        childs: [
            {
                shortcutId: 7,
                webpartId: '',
                categoryId: 0,
                title: '교보문고',
                titleEn: '',
                titleCh: '',
                titleJp: '',
                image: '',
                linkUrl: 'https://www.kyobobook.co.kr',
                order: 1,
                isUse: true,
                isMain: true,
                isPopup: false
            }
        ]
    },
    {
        id: 2,
        displayName: '그룹사',
        childs: [
            {
                shortcutId: 7,
                webpartId: '',
                categoryId: 0,
                title: '교보생명',
                titleEn: '',
                titleCh: '',
                titleJp: '',
                image: '',
                linkUrl: 'https://www.kyobo.com',
                order: 1,
                isUse: true,
                isMain: true,
                isPopup: false
            }
        ]
    },
    {
        id: 3,
        displayName: '유관기관',
        childs: [
            {
                shortcutId: 7,
                webpartId: '',
                categoryId: 0,
                title: '전자공시시스템',
                titleEn: '',
                titleCh: '',
                titleJp: '',
                image: '',
                linkUrl: 'https://dart.fss.or.kr',
                order: 1,
                isUse: true,
                isMain: true,
                isPopup: false
            }
        ]
    },
]

@Component({
    name: 'kbb-external-shortcut-webpart',
    components: {
        WebpartTemplate,
        LoadingBar,
        NoData,
        ExternalShortcutSettingModal
    },
    computed: mapGetters({
        current: accouttypes.CURRENT,
    }),
})
export default class ExternalShortcutWebpart  extends Mixins(WebpartBase) {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //
    @Prop({ type: Object }) webpart!: webpartv3.Webpart;

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    current!: account.TCurrent;

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //
    options: any = null;

    categoryList: kyobobook.ShortcutCategory[] = [];
    shortcutList: kyobobook.Shortcut[] = [];

    displayModel: GroupShortcutModel[] = [];

    isShortcutManager: boolean = false;

    curCategoryId: number = 0;

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    // 웹파트 옵션 저장값 set
    setProps() {
        this.options =
        typeof this.webpart.props == typeof '' ? JSON.parse(this.webpart.props as string) : this.webpart.props;
    }

    async handleClickLink(link: kyobobook.Shortcut) {
        if (this.preview) return;

        if(link.shortcutId) this.addClickCount(link.shortcutId);

        var url = link.linkUrl;
        var features = ''
        var target = '_blank'

        if((/\$\{[A-Za-z0-9]+\}/g).test(url)){
            let urlReplaced = replaceUserKeyword(url, this.current.user);
            url = urlReplaced
        }
        if (url.includes('api/processToken')) {
            var _url = new URL(url)

            var searchParams = _url.searchParams

            var redirect = searchParams.get("redirectUrl") ?? "_blank"
            _url.searchParams.delete("redirectUrl")

            var search: string[] = []
            search.push(`personCode=${this.current.user.personCode}`, `timeStamp=${new Date().getTime()}`)
            if (_url.search !== '') {
                var _search = _url.search.slice(1).split('&')
                search = search.concat(_search)
            }
            var params = this.getParams(search)

            url = this.isTeams ? await urlHelper.redirectWithProcessToken(redirect, params, this.current.user.comCode, this.current.key)
                : `${window.location.origin}${process.env.NODE_ENV === 'production' ? '/po' : ''}${redirect}`;
            
            target = redirect
        } else if(url.includes('page/hmac')) {
            var _url = new URL(url);

            var searchParams = _url.searchParams;

            var redirect = searchParams.get("redirectUrl") ?? "";
            redirect = decodeURIComponent(redirect);
            _url.searchParams.delete("redirectUrl");

            const token = `personCode=${this.current.user.personCode}&actionUrl=${redirect}`;

            const rsa = new SubtleRSA(this.current.key);
            await rsa.initialize();
            const encrypted = await rsa.encrypt(token);

            url = `${window.location.origin}/cm/Kyobobook/redirect/page/hmac?token=${encodeURIComponent(encrypted)}`;
        }
        
        if(link.isPopup) features = buildStyle({ width: 900, height: 800 })

        window.open(url, target, features);
  
    }

    getParams(search: string[]) {
        var res = ''

        for (var i = 0; i < search.length; i++) {
            res += `&${search[i]}`
        }

        if (res.startsWith('&'))
            res = res.slice(1)

        return res
    }

    addClickCount(shortcutId: number) {
        if(this.webpart.id) {
            api.kyobobook.addClickCount(this.webpart.id, shortcutId);
        }
    }

    handleClickDropdown(id: number) {
        if(this.curCategoryId != id) {
            this.curCategoryId = id;
        } else {
            this.curCategoryId = 0;
        }
    }

    openSettingModal(){
        const modal: appbase.IModalOpenable = this.$refs['modal'] as any
        const options: appbase.TModalInfo<any> = {
          component: ExternalShortcutSettingModal,
          props: { webpartId: this.webpart.id },
          events: {
            cancel: () => {
              modal.closeModal()
            },
          },
        }
        modal.openModal(options)
    }

    load() {
        this.loading = true;

        if(this.current.permissions.roles.length>0){
            this.isShortcutManager = this.current.permissions.isCompanyManager || this.current.permissions.isSuperAdmin || this.current.permissions.roles.find(i=>i.roleType.toLowerCase()=='banner')!=undefined
        }

        if (this.webpart.id) {
            Promise.all([
                api.kyobobook.getShortcutCategoryList(this.webpart.id!),
                api.kyobobook.getShortcutList(this.webpart.id!)
            ]).then(res => {
                this.categoryList = res[0];
                this.shortcutList = res[1];
    
                this.displayModel = this.categoryList.map(c => {
                    const displayModelItem: GroupShortcutModel = {
                        id: c.categoryId!,
                        displayName: c.title,
                        childs: []
                    }
    
                    const shortcuts = this.shortcutList.filter(s => s.categoryId == c.categoryId);
                    shortcuts.forEach(s => {
                        displayModelItem.childs.push(s);
                    });
    
                    return displayModelItem;
                });
            }).finally(() => {
                this.loading = false;
            });
        } else {
            this.loading = false;
        }
    }

    @Watch('webpart.props')
    changeWebpartValue() {
        this.setProps();
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E S T Y L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //
    created() {
        if (this.webpart && this.webpart.props) {
            this.setProps();
        }

        if (this.preview) {
            this.displayModel = tempData;
        } else {
            this.load();
        }
    }

}